module.exports = __webpack_public_path__ + "img/no-find-hotel.7485201b.png";